export var GlobalMessageTypes;
(function (GlobalMessageTypes) {
    GlobalMessageTypes["CONFIRM"] = "confirm";
    GlobalMessageTypes["ERROR"] = "error";
    GlobalMessageTypes["INFO"] = "info";
})(GlobalMessageTypes || (GlobalMessageTypes = {}));
